import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { brand } from './brand';

interface AttributeTableProps {
    attributes: Record<string, unknown>;
}

const toDisplayValue = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    return String(value);
};

const toLabel = (key: string): string => key.replace(/[_-]/g, ' ');

export const AttributeTable: FC<AttributeTableProps> = ({attributes}) => {
    const {t} = useTranslation();
    const entries = Object.entries(attributes);

    if (entries.length === 0) {
        return (
            <Typography sx={{color: brand.text}}>
                {t('steps.verify.noAttributes')}
            </Typography>
        );
    }

    return (
        <Box sx={{border: `1px solid ${brand.border}`, borderRadius: '12px', overflow: 'hidden'}}>
            <Table size="small">
                <TableBody>
                    {entries.map(([key, value]) => (
                        <TableRow key={key} sx={{'&:last-child td': {borderBottom: 0}}}>
                            <TableCell sx={{
                                color: brand.text,
                                textTransform: 'capitalize',
                                width: '40%',
                                borderColor: brand.border,
                            }}>
                                {toLabel(key)}
                            </TableCell>
                            <TableCell sx={{color: brand.navy, fontWeight: 500, borderColor: brand.border}}>
                                {toDisplayValue(value)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};
